var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.75C7.245 1.75 1.75 7.245 1.75 14C1.75 20.755 7.245 26.25 14 26.25C20.755 26.25 26.25 20.755 26.25 14C26.25 7.245 20.755 1.75 14 1.75ZM10.5 12.4513L13.0375 14.9975L17.5 10.535L18.7337 11.7688L13.0375 17.465L9.26625 13.6937L10.5 12.4513ZM14 22.75C9.17875 22.75 5.25 18.8213 5.25 14V13.125H7V14C7 17.8587 10.1413 21 14 21C17.8587 21 21 17.8587 21 14C21 10.1413 17.8587 7 14 7H13.125V5.25H14C18.8213 5.25 22.75 9.17875 22.75 14C22.75 18.8213 18.8213 22.75 14 22.75Z",
    fill: "#7A990E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.3a5c706e8d6f297ffe168d37112d7e1a.svg";
export { ForwardRef as ReactComponent };